import { baseApi } from "@/data/restApi/baseApi";
import { ListResponse, IdResult } from "@/common/baseTypes";
import { UserRepository } from "@/data/userRepository";
import { LoginRequest } from "@/common/authTypes";
import {
  convertErrorToUserMessage,
  unwrapResponseData
} from "@/data/restApi/resUtils";

class UserRestRepository implements UserRepository {
  login(password: string): Promise<void> {
    return baseApi
      .post("/auth/login", <LoginRequest>{
        password
      })
      .then(res => res.data)
      .catch(err => {
        throw convertErrorToUserMessage(err);
      });
  }

  logout(): Promise<void> {
    return baseApi.get("/auth/logout").then(unwrapResponseData);
  }
}

export default new UserRestRepository();
